import config from "../../config.js";
import axios from "axios";

// Fetch single vehicle visit status
export const fetchVehicleVisitStatus = async (stopId, vehicleId) => {
  try {
    const response = await axios.get(`${config.baseURL}/stop/${stopId}/${vehicleId}`);
    if (response.data.error) {
      return null; // Handle "not found" as null
    }
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching visit status for ${stopId}_${vehicleId}:`,
      error.message
    );
    return null;
  }
};

// Batch fetch vehicle visit statuses for a stop
export async function batchFetchVehicleVisitStatuses(stopId, vehicleIds) {
  if (!vehicleIds.length) return {};

  const vehicleIdsQuery = vehicleIds.join(",");
  
  // Encode stopId dynamically
  const encodedStopId = encodeURIComponent(stopId);

  const response = await fetch(
    `${config.baseURL}/stop/${encodedStopId}/batch-get?vehicleIds=${vehicleIdsQuery}`
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch statuses for stop ${stopId}`);
  }

  return response.json();
}

// Update (create or upsert) vehicle visit status
export const updateVehicleVisitStatus = async (
  stopId,
  vehicleId,
  direction,
  distance_to_source,
  distance_to_destination,
  in_proximity,
  last_calculated_distance,
  last_calculated_eta,
  visitedDirection, // string (e.g., "source_to_dest")
  route_coordinates = [], // Array of coordinate points
  stop_to_stop_distances = {}, // Object with stopId: distance pairs
) => {
  try {
    const response = await axios.post(`${config.baseURL}/stop/createvehiclevisitStatus`, {
      stopId,
      vehicleId,
      direction,
      distance_to_source,
      distance_to_destination,
      in_proximity,
      last_calculated_distance,
      last_calculated_eta,
      visitedDirection: visitedDirection || direction, // Fallback to direction if null
      route_coordinates,
      stop_to_stop_distances,
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error updating visit status for ${stopId}_${vehicleId}:`,
      error.message
    );
    return null;
  }
};